/**
 * Leasing page payment calculator: linear markup formula.
 * Удорожание = Тело_лизинга * ставка * (срок/12); платёж = (Тело + Удорожание) / срок.
 */
(() => {
    const ANNUAL_RATE = 0.10;

    function parseCost(value) {
        const digits = value.replace(/[^\d]/g, '');
        return digits ? parseInt(digits, 10) : 0;
    }

    function animateValue(el, from, to, durationMs) {
        const start = performance.now();
        function tick(now) {
            const progress = Math.min((now - start) / durationMs, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = Math.round(from + (to - from) * eased);
            el.textContent = `~${current.toLocaleString('ru-RU')} ₽`;
            if (progress < 1) {
                requestAnimationFrame(tick);
            }
        }
        requestAnimationFrame(tick);
    }

    function calculate(root) {
        const costInput = root.querySelector('[data-calc-cost]');
        const advanceSelect = root.querySelector('[data-calc-advance]');
        const termSelect = root.querySelector('[data-calc-term]');
        const valueEl = root.querySelector('[data-calc-value]');
        const noteEl = root.querySelector('[data-calc-note]');
        if (!costInput || !advanceSelect || !termSelect || !valueEl || !noteEl) {
            return;
        }

        const cost = parseCost(costInput.value);
        const advancePercent = parseFloat(advanceSelect.value) || 0;
        const term = parseInt(termSelect.value, 10) || 1;

        const advanceAmount = Math.round(cost * advancePercent / 100);
        const principal = cost - advanceAmount;

        const markup = principal * ANNUAL_RATE * (term / 12);
        const monthlyPayment = principal > 0
            ? Math.round((principal + markup) / term)
            : 0;

        const previousValue = parseCost(valueEl.textContent);
        animateValue(valueEl, previousValue, monthlyPayment, 1100);
        noteEl.textContent = `ПРИ АВАНСЕ ${advanceAmount.toLocaleString('ru-RU')} ₽`;

        costInput.value = cost.toLocaleString('ru-RU');
    }

    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-calc-submit]');
        if (!button) {
            return;
        }
        const root = button.closest('[data-payment-calculator]');
        if (root) {
            calculate(root);
        }
    });

    document.querySelectorAll('[data-payment-calculator]').forEach(calculate);
})();
